import { ExportOutlined } from "@ant-design/icons";
import { Button, Input, Space } from "antd";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { useState } from "react";
import { ExportGeneratorSelector } from "../../controls/ExportGeneratorSelector";
import { ModelSelector } from "../../controls/ModelSelector";
import { PageTitle } from "../../controls/PageTitle";
import { PageWrapper } from "../../controls/PageWrapper";
import { domain } from "../../domain/domain";
import { IExportGenerator } from "../../domain/ExportGenerators/IExportGenerator";
import { IModelInfo } from "../../domain/ModelInfos/IModelInfo";
import { useDatasource } from "../../hooks/useDatasource";
import { formatDateTime } from "../../domain/helpers/tsHelper";

export function ExportPage(props: {}) {

    const dsModels = useDatasource(() => domain.modelInfoService.get(), []);
    const exportGenerators = domain.exportGeneratorService.getExportGenerators();
    const [selectedModels, setSelectedModels] = useState<IModelInfo[]>([]);
    const [selectedGenerators, setSelectedGenerators] = useState<IExportGenerator[]>([]);
    const [jsonUrl, setJsonUrl] = useState<string>("http://localhost:4321/");
    const [templatesUrl, setTemplatesUrl] = useState<string>("http://localhost:4321/");

    async function exportClick() {
        if (selectedModels.length < 1) return;
        const artifacts = domain.exportGeneratorService.generateArtifacts(selectedGenerators, selectedModels);
        console.log("generated artifacts", artifacts);
        if (artifacts.length < 1) return;
        const zip = new JSZip();
        for (const artifact of artifacts) {
            zip.file(artifact.fileName, artifact.content);
        }
        const content = await zip.generateAsync({ type: "blob" });
        const date = formatDateTime(new Date());
        saveAs(content, `export-${date}.zip`);
    }

    function exportJsonClick() {
        if (selectedModels.length < 1) return;
        const content = new Blob([JSON.stringify(selectedModels, null, 4)]);
        const date = formatDateTime(new Date());
        saveAs(content, `export-${date}.json`);
    }

    function exportJsonUrlClick() {
        if (selectedModels.length < 1) return;
        const json = JSON.stringify(selectedModels, null, 4);
        fetch(jsonUrl, { method: "POST", body: json, headers: { "content-type": "application/json" } });
    }

    function exportTemplatesUrlClick() {
        if (selectedModels.length < 1) return;
        const artifacts = domain.exportGeneratorService.generateArtifacts(selectedGenerators, selectedModels);
        const json = JSON.stringify(artifacts, null, 4);
        fetch(templatesUrl, { method: "POST", body: json, headers: { "content-type": "application/json" } });
    }

    return (<PageWrapper>
        <PageTitle title="Export" />
        <div style={{ padding: 24, minHeight: 360, backgroundColor: "#fff" }}>
            <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
                <ModelSelector models={dsModels.data} onChange={setSelectedModels} />
                <Space>
                    <Button type="primary" icon={<ExportOutlined />} onClick={exportJsonClick}>Export JSON</Button>
                </Space>
                <Space direction="horizontal">
                    <Input style={{ width: 400 }} value={jsonUrl} onChange={(e) => setJsonUrl(e.target.value)} />
                    <Button type="primary" icon={<ExportOutlined />} onClick={exportJsonUrlClick}>Export JSON to url</Button>
                </Space>
                <ExportGeneratorSelector generators={exportGenerators} onChange={setSelectedGenerators} />
                <Space>
                    <Button type="primary" icon={<ExportOutlined />} onClick={exportClick}>Export template(s)</Button>
                </Space>
                <Space direction="horizontal">
                    <Input style={{ width: 400 }} value={templatesUrl} onChange={(e) => setTemplatesUrl(e.target.value)} />
                    <Button type="primary" icon={<ExportOutlined />} onClick={exportTemplatesUrlClick}>Export template(s) to url</Button>
                </Space>
            </Space>
        </div>
    </PageWrapper>
    );
};